"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _default;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _loadScript = _interopRequireDefault(require("./loadScript"));

/*
 * function: loads sfly-auth(ip2) library if it is not already loaded
 *  @params : none
 *  @return : promise: to initiate the sfly auth
 *  by amsingh
 */
function _default() {
  if (window.initSflyAuth) {
    return _promise.default.resolve(window.initSflyAuth);
  }

  return (0, _loadScript.default)("https://".concat((0, _uigCurrentEnvironmentUtil.getCDNHostname)(), "/sfly-sso-client/dist/zuul.js")).then(function () {
    return window.initSflyAuth;
  });
}

//# sourceMappingURL=loadSflyAuth.js.map